<template>
    <v-row justify="center">
    <v-dialog v-model="abrir" persistent max-width="600px">
      <v-card>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                  <v-textarea
                    solo
                    name="input-7-4"
                    label="Escriba un comentario..."
                    v-model="observacion"
                  ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" dark @click="abrir = false">Cancelar</v-btn>
          <v-btn color="green darken-1" dark @click="guardar">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import {mapState} from 'vuex';
export default {
    data:()=>({
        registro:{},
        abrir:false,
        observacion:''
    }),
    beforeDestroy() {
        Event.$off('abrir_modal_comentar_traza');
    },
    mounted(){
        Event.$on('abrir_modal_comentar_traza',(registro)=>{
            console.log('registro recibidooo');
            this.registro = registro;
            this.observacion = registro.obs;
            console.log('registro recibido',registro);
            this.abrir = true;
        });
    },
    methods: {
        guardar(){
            console.log('comentario',this.observacion);
            let body = {}
            let tkt = this.registro.ticket != '' ? this.registro.ticket : this.registro.ticket_r;
            body = {
                ticket: tkt,
                fecha: this.registro.fecha,
                lote: this.registro.lote,
                jumbos: this.registro.maxis,
                observacion: this.observacion,
            }
            let url = `${this.base_url}traza/comentar`;
            this.axios.post(url,body,this.headers).then((response)=>{
                console.log('comentario creado',response);
                this.registro.obs = response.data.data.observacion;
                //this.$emit('actualizar_comentario_parametro',this.registro);
                this.limpiar();
            }).catch((error)=>{
                console.log('error',error);
            })
              
        },
        limpiar(){
          this.abrir = false;
          this.observacion = '';
        }
    },
    computed: {
      ...mapState(['base_url','headers']),
    },
}
</script>